import { Outlet } from 'react-router-dom';
import './AuthLayout.css';

/**
 * Authentication Layout
 * Now using Router <Outlet /> for nested routing
 */
export const AuthLayout = () => {
    return (
        <div className="auth-layout">
            <Outlet />
        </div>
    );
};
